import { InputSelectProps } from '@dirootie-web/components-types';
import { SelectSystemEnum } from '@components-common/forms';
import { BuildingTypeList } from './types/building-type';

export const BuildingTypeSelector = (props: Omit<InputSelectProps, "options"|"formState"|"id">) => (
  <SelectSystemEnum id="buildingType" {...props} items={BuildingTypeList as any}/>
);
